import produce from 'immer';

const INITIAL_STATE = {
  data: null,
};

export default function cursos(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case '@cursos/CURSOS_REQUEST_SUCCESS': {
        draft.data = action.payload.cursos;
        break;
      }
      case '@cursos/CURSOS_REQUEST_FAILURE': {
        draft.data = null;
        break;
      }
      case '@unidade/UNIDADE_SELECIONADA_SUCCESS': {
        draft.data = null;
        break;
      }
      case '@unidade/UNIDADE_SELECIONADA_FAILURE': {
        draft.data = null;
        break;
      }
      case '@auth/SIGN_OUT': {
        draft.data = null;
        break;
      }
      default:
    }
  });
}
